import { SET_THEME_COLOR } from "./actionTypes"

const initialState = {
  color: localStorage.getItem("themeColor"),
};

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME_COLOR:
      return { ...state, color: action.payload };
    default:
      return state;
  }
}

export default themeReducer